<template>
    <div class='panel'>
        <KZPrice :price="price" :color="color"/>
        <KZFrame :sum="sum" :color="color"/>
    </div>
</template>

<script>
import KZFrame from './KZFrame.vue';
import KZPrice from './KZPrice.vue';

export default {
  name: 'KZMainPanel',
  components: { KZFrame, KZPrice },
  props: {
    price: Number,
    sum: String,
  },
  computed: {
    color() {
      switch (this.price) {
        case 250:
          return 'gray';
        case 500:
          return 'blue';
        case 1000:
          return 'green';
        case 2000:
          return 'orange';
        case 3000:
          return 'red';
        default:
          return 'gray';
      }
    },
  },
};
</script>

<style scoped>
.panel {
    justify-content: center;
    display: flex;
    align-items: center;
    margin: .5rem 0;
    padding-right: 140px;
}
</style>
